import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import * as actions from '../../store/actions/index';
import ListItem from '../../components/UI/List/ListItem/ListItem';
import useInterval from '../../hooks/useInterval';
import { MINUTE_IN_MILLISECONDS } from '../../shared/constants';
import useScreenStyles from '../useScreenStyles';

const TrainStationPredictions = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useScreenStyles();
    const selectedTrainStation= useSelector((state) => state.cta.selectedStop);
    const predictions = useSelector((state) => state.cta.predictions);
    const isLoading = useSelector((state) => state.cta.loading);
    const message = useSelector((state) => state.cta.message);

    const onLoadTrainStationPredictions = useCallback(
        () => dispatch(actions.loadCtaTrainStationPredictions(selectedTrainStation.stopId)),
        [dispatch, selectedTrainStation]
    );

    const onBackButtonHandler = () => {
        history.goBack();
    }

    const hasPredictions = () => {
        return (
            predictions &&
            predictions.length > 0 &&
            message === null
        );
    }

    useEffect(() => {
        onLoadTrainStationPredictions();
    }, [onLoadTrainStationPredictions]);

    useInterval(() => {
        onLoadTrainStationPredictions();
    }, MINUTE_IN_MILLISECONDS);

    if (isLoading) {
        return <LinearProgress />;
    }

    return (
        <React.Fragment>
            <Box display="flex">
                <IconButton aria-label="back" onClick={onBackButtonHandler}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography className={classes.headerTitle}>
                    {`#${selectedTrainStation.stopId} | ${selectedTrainStation.stopName}`}
                </Typography>
            </Box>
            <Divider light />
            {!hasPredictions()
                ? <p>{message}</p>
                : predictions.map((pred) => (
                    <ListItem key={pred.trainRunNumber} item={pred} routeColor={pred.routeColor} />
                  ))
            }
        </React.Fragment>
    );
};

export default TrainStationPredictions;